<template>
  <div id="app">
		 <p class="news-title">我的团队</p>
          <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onJiazai" :immediate-check="immediate">
				<van-cell v-for="(list, index) in list" :key="index" class="span12 icon_img " id="" :icon="list.headimgurl"  center :title="list.nickname+list.mobile "  :label="list.create_time"  >
					<div v-if="list.vip==2" style="color: red;">已开通</div>
					<div v-else>未开通</div>
				</van-cell>
				
          </van-list>
    <div class="h-50"></div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      list: [],
      immediate:false,
      loading: false,
      finished: false,
      page: 1,//请求第几页
      total: 0,//总共的数据条数
    }
  },
  components: {
  },
  created:function () {
      this.$emit('footer', false);
  },
  mounted () {
    this.recordapi();
  },
  	methods: {
      tiao(e){
        this.$router.push('Newscont?id='+e)
        console.log(e);
      },
      recordapi(){
          var that = this;
          var userid = that.$cookieStore.getCookie('userid');
          that.$api.post("/Index/teamlist",{'page':this.page,'userid':userid}).then(res => {
            console.log(res);
            let rows = res.list.data; //请求返回当页的列表
            // // console.log(that.page);
            console.log(rows)
             that.loading  = false;
             that.pageSize = res.list.per_page;
             that.total    = res.list.total;
             if (rows == null || rows.length === 0) {
               // 加载结束
               that.finished = true;
               return;
             }
            // 将新数据与老数据进行合并
             that.list = that.list.concat(rows);
            // //如果列表数据条数>=总条数，不再触发滚动加载
            if(that.list.length >= that.total){
               that.finished = true;
            }
          });
      },
      // 加载
      onJiazai:function(){
        var that = this;
        that.page++;
        console.log(that.page)
        that.recordapi()
      },
    }
}
</script>
<style>
	.icon_img img{width: 40px;height: 40px;border-radius: 20px;}
	.icon_img .van-cell__left-icon{height: 40px !important;}
</style>


// WEBPACK FOOTER //
// src/components/Team.vue